import { Checkbox, FormControlLabel } from "@material-ui/core";
import {
  DragIndicator,
  ExpandLess,
  ExpandMore,
  Settings,
} from "@material-ui/icons";
import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../../../../context/auth";
import AdminStamp from "../../AdminStamp";
import {
  BusinessUnitColor,
  BusinessUnitName,
  CommitteesList,
  CommitteesText,
  CommittesSection,
  Container,
  ExpandButton,
  ExpandContainer,
  GroupItem,
  GroupsList,
  GroupsSection,
  Header,
  PackageCommitteeContent,
  PackageCommitteeHeader,
  PackageCommitteeItem,
  PackageCommitteeName,
  PackageCommitteesContainer,
  PackageDragButton,
  SettingsButton,
  SettingsContainer,
  SubItemTitle,
} from "./styles";

interface IBusinessUnitCardProps {
  businessUnit: {
    id: string;
    name: string;
    active: boolean;
    color: string;
    committeePackages: {
      id: string;
      active: boolean;
      isAdmin: boolean;
      name: string;
      committees: {
        id: string;
        name: string;
        activated: boolean;
      }[];
      groups: {
        id: string;
        name: string;
        active: boolean;
      }[];
    }[];
  };
  groupSelectable?: boolean;
  selectedGroup?: string;
  canUpdateGroup?: boolean;
  canUpdateCommittee?: boolean;
  canUpdatePackage?: boolean;
  setSelectedGroup?: (id: string) => void;
}

const BusinessUnitCard: React.FC<IBusinessUnitCardProps> = ({
  businessUnit,
  groupSelectable = false,
  selectedGroup,
  setSelectedGroup,
  canUpdateCommittee = false,
  canUpdateGroup = false,
  canUpdatePackage = false,
}) => {
  const history = useHistory();
  const { userInfo } = useAuth() as any;

  const [expandedPackageId, setExpandedPackageId] = useState<
    string | undefined
  >();

  const handleToggleExpanded = useCallback(
    (packageId: string) => {
      if (expandedPackageId === packageId) {
        setExpandedPackageId(undefined);
      } else {
        setExpandedPackageId(packageId);
      }
    },
    [expandedPackageId]
  );

  return (
    <Container active={businessUnit.active}>
      <Header>
        <BusinessUnitColor color={businessUnit.color} />
        <BusinessUnitName active={businessUnit.active}>
          {businessUnit.name}
        </BusinessUnitName>

        <SettingsContainer>
          <SettingsButton
            disabled={userInfo?.master ? false : true}
            to={
              userInfo?.master
                ? `/system-management/configure-business?id=${businessUnit.id}`
                : "#"
            }
          >
            <Settings />
          </SettingsButton>
        </SettingsContainer>
      </Header>

      <PackageCommitteesContainer>
        {businessUnit.committeePackages.map((packageItem) => (
          <PackageCommitteeItem key={packageItem.id} draggable>
            <PackageCommitteeHeader
              onClick={() => handleToggleExpanded(packageItem.id)}
            >
              <PackageDragButton>
                <DragIndicator />
              </PackageDragButton>
              <PackageCommitteeName
                active={packageItem.active}
                to={
                  canUpdatePackage
                    ? `/system-management/configure-committee-packages?id=${packageItem.id}`
                    : "#"
                }
              >
                {packageItem.name}

                {packageItem.isAdmin && (
                  <AdminStamp name="Admin" color="#f96e6e" />
                )}
              </PackageCommitteeName>

              <ExpandContainer>
                <ExpandButton>
                  {expandedPackageId === packageItem.id ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )}
                </ExpandButton>
              </ExpandContainer>
            </PackageCommitteeHeader>

            {expandedPackageId === packageItem.id && (
              <PackageCommitteeContent>
                <CommittesSection>
                  <SubItemTitle>Comitês</SubItemTitle>

                  <CommitteesList>
                    {packageItem.committees.map((committee, index) => {
                      return (
                        <CommitteesText
                          active={committee.activated}
                          to={
                            canUpdateCommittee
                              ? `/system-management/configure-committees?id=${committee.id}`
                              : "#"
                          }
                          key={committee.id}
                        >
                          {`${committee.name}${
                            index === packageItem.committees.length - 1
                              ? ""
                              : ", "
                          } `}
                        </CommitteesText>
                      );
                    })}
                  </CommitteesList>
                </CommittesSection>
                <GroupsSection>
                  <SubItemTitle>Grupos</SubItemTitle>

                  <GroupsList
                    style={{
                      ...(groupSelectable && { listStyleType: "none" }),
                    }}
                  >
                    {packageItem.groups.map((group) => {
                      return groupSelectable ? (
                        <li>
                          <FormControlLabel
                            control={
                              <Checkbox
                                value={selectedGroup === group.id}
                                checked={selectedGroup === group.id}
                                onChange={() =>
                                  setSelectedGroup
                                    ? setSelectedGroup(group.id)
                                    : () => {
                                        return;
                                      }
                                }
                                name={group.name}
                                id={group.name}
                                color="primary"
                              />
                            }
                            label={group.name}
                          />
                        </li>
                      ) : (
                        <GroupItem
                          active={group.active}
                          key={group.id}
                          onClick={() => {
                            if (!canUpdateGroup) return;

                            history.push(
                              `/system-management/configure-groups?id=${group.id}`
                            );
                          }}
                        >
                          {group.name}
                        </GroupItem>
                      );
                    })}
                  </GroupsList>
                </GroupsSection>
              </PackageCommitteeContent>
            )}
          </PackageCommitteeItem>
        ))}
      </PackageCommitteesContainer>
    </Container>
  );
};

export default BusinessUnitCard;
